<script lang="ts">
	import AuthAPI from '$lib/api/auth';
	import { Button } from '$lib/components/ui/button';
	import { t } from '$lib/i18n';
	import { isDesktop, isToken } from '$lib/stores/storeCommon';
	import { storeUserInfo } from '$lib/stores/storeUser';
	import { cn } from '$lib/utils';
	import { connectWallet, onDisconnect, isRequestingMessage } from '$lib/web3/wagmi';
	import { zeroAddress } from 'viem';

	let className: string | undefined = undefined;
	export { className as class };
	export let drawerOpen: boolean = false;

	const handleConnect = async () => {
		await connectWallet();
		if (!$isDesktop) drawerOpen = false;
	};

	const onHandleDisconnect = async () => {
		await AuthAPI.logout();
		await onDisconnect();
		if (!$isDesktop) drawerOpen = false;
	};
</script>

{#if $storeUserInfo.web3_address === zeroAddress || $isToken === undefined}
	<div class="">
		<Button
			disabled={$isRequestingMessage}
			class={cn('bg-[#481555] font-bold xl:bg-[#29193D] xl:px-[20px] xl:py-[10px] ', className)}
			on:click={handleConnect}
		>
			<div class="flex items-center gap-x-2">
				<img src="/img/desktopNav/wallet.png" alt="wallet" class="w-5 -translate-y-[1px]" />
				<p class="pixel-font text-sm xl:text-md">{$t('common.connect_wallet')}</p>
			</div>
		</Button>
	</div>
{:else}
	<Button
		class={cn('bg-[#29193D] px-[20px] py-[10px] text-sm font-bold xl:text-md ', className)}
		on:click={onHandleDisconnect}>{$t('common.disconnect')}</Button
	>
{/if}
